module.exports = __webpack_public_path__ + "img/5_65.5378a2ea.png";